import http from "./httpService";

const apiEndPoint = "/videorecordertypes/";

function getVideoRecorderTypes() {
  return http.get(apiEndPoint);
}

export default getVideoRecorderTypes;
